import UntrackedModel from "../untracked/untrackedModel";
import {CorrespondenceType} from "./correspondences/correspondenceType";
import ICorrespondence from "../../interfaces/correspondenceInterfaces";

export default class Correspondence extends UntrackedModel implements ICorrespondence {
  correspondence_type: CorrespondenceType = CorrespondenceType.Correspondence;
  text: string = '';
  author: any = {};
  author_id: string = null;
  form_submission_id: string = null;

  get isAMessage(): boolean {
    return false;
  }

  get isANote(): boolean {
    return false;
  }
}
